import React from 'react';
import {alpha, Stack, styled} from '@mui/material';
import {
  Body,
  Button,
  designSystemToken,
  Headline,
  Icon,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './FinalCreditModalContent.module.scss';

const featuresYouGet = [
  'More credits',
  'No watermark',
  'Extra team seats',
  'Basic support',
];

const IconWithBackground = styled(Icon, {
  shouldForwardProp: (prop) => prop !== 'bgColor',
})<{
  bgColor?: string;
}>(({bgColor}) => ({
  backgroundColor: bgColor,
  borderRadius: '999px',
  padding: '4px',
}));

function FinalCreditModalContent({
  onClose,
  onRedirectToPricing,
}: {
  onClose: () => void;
  onRedirectToPricing: () => void;
}) {
  return (
    <Stack className={styles.container}>
      <Headline size="md" marginBottom="8px">
        {translate(
          'Your Project Is Being Created! Unlock More Credits to Keep Going'
        )}
      </Headline>
      <Body size="md" marginBottom="16px">
        {translate(
          'Your current project is generating. Continue scaling your content faster with an upgraded plan.'
        )}
      </Body>
      <Stack direction="row" gap="12px">
        <IconWithBackground
          name="Features-Flash-Fill"
          size="medium"
          appearance="brand"
          bgColor={alpha(designSystemToken('semantic.bg.brand-secondary'), 0.3)}
        />
        <Stack marginBottom="16px">
          <Headline size="xxs" marginBottom="16px">
            {translate('Upgrade your plan to get:')}
          </Headline>
          {featuresYouGet.map((feature) => (
            <Stack direction="row" gap="8px" marginBottom="8px" key={feature}>
              <Icon name="Actions-Accept" size="small" appearance="primary" />
              <Body size="md">{translate(feature)}</Body>
            </Stack>
          ))}
        </Stack>
      </Stack>

      <Button
        appearance="neutral"
        mode="filled"
        size="medium"
        sx={{marginBottom: '8px', marginTop: '56px'}}
        onClick={onRedirectToPricing}
      >
        {translate('Contact Sales')}
      </Button>
      <Button appearance="neutral" mode="plain" size="medium" onClick={onClose}>
        {translate('Back to Results')}
      </Button>
    </Stack>
  );
}

export default FinalCreditModalContent;
